define('views/peoplefinder/Podio.Views.PeopleFinder.Email',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','jst!peoplefinder/_email'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstEmail = require('jst!peoplefinder/_email');

  return ViewPodioBase.extend({
    initialize: function() {
      _.bindAll(this, 'onPickerEmailAdded', 'onPickerEmailRemoved');

      this.dataGroup = 'mail';
      this.render();
    },

    getExistingData: function() {
      var values = _.flatten(this.model.attributes);
      var self = this;

      return _.filter(values, function(item) {
        return item.ref_type === self.dataGroup;
      });
    },

    render: function() {

      var prepopulateData = this.getExistingData();

      this.elm.html(this.getTemplate(jstEmail, {
        lead_text: t('Type email addresses of connections you want to select #contact_app_type')
      }));
      this.elmInput = this.elm.find('input');

      this.elmInput.podioPicker({
        initialFocusInInput: true,
        allowFreeTokens: true,
        freeTokenMode: 'email',
        showTopList: false,
        disableQueries: true,
        onDataRequest: $.noop,
        prePopulate: prepopulateData,
        onAfterFreeTokenAdded: this.onPickerEmailAdded,
        onAfterTokenRemoved: this.onPickerEmailRemoved,
        classes: { tokenList: 'token-input-list fluid people-finder-email' },
        placeholderText: t('Enter an email address #peoplefinder'),
        inputTokenIcon: 'icon-mail-light'
      });

      this.elm.removeClass('loading-overlay-small');

    },

    destroy: function() {
      this.elm.empty();
    },

    onPickerEmailAdded: function(email) {
      this.trigger('peopleFinderEmail:emailAdded', email);
    },

    onPickerEmailRemoved: function(tokenList, email) {
      this.trigger('peopleFinderEmail:emailRemoved', email);
    }
  });

});

